// API client for Activity Center & Notifications

import { api } from './api';
import type {
  ActivityListResponse,
  MissedSummary,
  NotificationListResponse,
  UnreadCountResponse,
} from '@/types/activityCenter';

// ── Activity Center ──

export async function getMissedSummary(since?: string): Promise<MissedSummary> {
  const params = since ? { since } : {};
  const { data } = await api.get('/crm/activity-center/missed', { params });
  return data;
}

export async function getMyActivity(params: {
  skip?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
}): Promise<ActivityListResponse> {
  const { data } = await api.get('/crm/activity-center/my-activity', { params });
  return data;
}

export async function getTeamFeed(params: {
  skip?: number;
  limit?: number;
  date_from?: string;
  date_to?: string;
  action_types?: string;
  entity_type?: string;
}): Promise<ActivityListResponse> {
  const { data } = await api.get('/crm/activity-center/feed', { params });
  return data;
}

// ── Notifications ──

export async function getNotifications(params: {
  is_read?: boolean;
  skip?: number;
  limit?: number;
}): Promise<NotificationListResponse> {
  const { data } = await api.get('/notifications/', { params });
  return data;
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const { data } = await api.get('/notifications/unread-count');
  return data;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.put(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.put('/notifications/read-all');
}
